export const ON_FOOTAGE_ADD = '@ARI/Questionnaire/Footage/ON_FOOTAGE_ADD';
export const ON_FOOTAGE_REMOVE = '@ARI/Questionnaire/Footage/ON_FOOTAGE_REMOVE';
export const SET_FOOTAGE_VALIDATORS = '@ARI/Questionnaire/Footage/SET_FOOTAGE_VALIDATORS';
export const SET_FOOTAGE_VALUES = '@ARI/Questionnaire/Footage/SET_FOOTAGE_VALUES';
export const SET_FOOTAGE_SETTINGS = '@ARI/Questionnaire/Footage/SET_FOOTAGE_SETTINGS';
export const SET_FOOTAGE_ERRORS = '@ARI/Questionnaire/Footage/SET_FOOTAGE_ERRORS';